import React from 'react';
import { TrendInfo } from '../../../types/api-models';
import { ArrowUpOutlined, ArrowDownOutlined, MinusOutlined } from '@ant-design/icons';

interface MetricCardHeaderProps {
  title: string;
  value: string | number;
  subtitle?: string;
  trend?: TrendInfo;
  previousLabel?: string;
  className?: string;
  inverseTrend?: boolean; // If true, Up=Bad (Red), Down=Good (Green)
}

export const MetricCardHeader: React.FC<MetricCardHeaderProps> = ({
  title,
  value,
  subtitle,
  trend,
  previousLabel = "vs previous 30 days",
  className = "",
  inverseTrend = false
}) => {
  
  // Helper to determine trend color and icon
  const getTrendVisuals = (direction: 'up' | 'down' | 'flat') => {
    // Standard: Up = Green, Down = Red
    // Inverse: Up = Red, Down = Green
    
    if (direction === 'flat') return { color: 'text-slate-400', Icon: MinusOutlined };

    if (direction === 'up') {
      return { 
        color: inverseTrend ? 'text-rose-500' : 'text-emerald-500', 
        Icon: ArrowUpOutlined 
      };
    } else {
      // Down
      return { 
        color: inverseTrend ? 'text-emerald-500' : 'text-rose-500', 
        Icon: ArrowDownOutlined 
      };
    }
  };

  const visuals = trend ? getTrendVisuals(trend.direction) : null;

  return (
    <div className={`flex flex-col space-y-1 ${className}`}>
      <h3 className="text-sm font-medium text-slate-500">{title}</h3>
      <div className="flex items-baseline justify-between">
        <div className="text-2xl font-bold text-slate-900">{value}</div>
        
        {trend && visuals && (
          <div className={`flex items-center space-x-1 text-sm font-medium ${visuals.color}`}>
            <visuals.Icon />
            <span>{Math.abs(trend.pct_change)}%</span>
            <span className="text-xs text-slate-400 font-normal ml-1">
              {previousLabel}
            </span>
          </div>
        )}
      </div>
      {subtitle && (
        <p className="text-xs text-slate-400">{subtitle}</p>
      )}
    </div>
  );
};
